import { render, staticRenderFns } from "./ViewStationPage.vue?vue&type=template&id=fee5635a&"
import script from "./ViewStationPage.vue?vue&type=script&lang=js&"
export * from "./ViewStationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports